.z-cover-container {
  position: relative;
  display: flex;
  width: 119px;
  height: 158px;
  align-items: center;
  justify-items: center;
}

.z-cover-stack {
  width: 100%;
  height: 100%;
}

/* Base sizes for single cover */
.z-cover-shadow,
.z-cover-img {
  width: 117px;
  min-width: 117px;
  max-width: 117px;
  height: 156px;
  min-height: 156px;
  max-height: 156px;
}

/* Scaled sizes for multiple covers */
.z-cover-container.has-multiple .z-cover-shadow,
.z-cover-container.has-multiple .z-cover-img {
  width: 105px;
  min-width: 105px;
  max-width: 105px;
  height: 140px;
  min-height: 140px;
  max-height: 140px;
}

.z-cover-shadow {
  position: absolute;
  z-index: 1;
  background-color: var(--color-white);
}

.z-shadow-1 {
  z-index: 1;
  top: var(--space-unit);
  right: 6px;
  border: var(--border-size-small) solid black;
}

.z-shadow-2 {
  z-index: 0;
  top: calc(var(--space-unit) * 2);
  right: 12px;
  border: var(--border-size-small) solid black;
}

.z-cover-img {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  border: var(--border-size-small) solid black;
  object-fit: cover;
  object-position: left;
}

.z-cover-container.has-multiple .z-cover-img {
  left: 12px;
}
